import moment from 'moment';
moment.locale('tr');

export function getMonthDateRange(year, month) {
  // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
  // array is 'year', 'month', 'day', etc
  var startDate = moment([year, month - 1]);

  // Clone the value before .endOf()
  var endDate = moment(startDate).endOf('month');

  // just for demonstration:
  // console.log(startDate.toDate());
  // console.log(endDate.toDate());

  // make sure to call toDate() for plain JavaScript date type
  return { start: startDate, end: endDate };
}

export function onlyHour(hour) {
  return moment(hour).format("HH:mm")
}

export function toNow(hour, serverTime) {
  // if (moment(hour).toNow('h') === 'bir saat') {
  //   return '1 saat'
  // }
  // return moment(hour).toNow()

  const now = moment(serverTime);
  const exp = moment(hour);

  const days = exp.diff(now, 'days');
  const hours = exp.subtract(days, 'days').diff(now, 'hours');
  const minutes = exp.subtract(hours, 'hours').diff(now, 'minutes');
  return `${hours === 0 ? '' : hours + ' saat'} ${minutes} dakika`;
}





// WEBPACK FOOTER //
// ./src/utils/date.js